import type { NavigateFunction } from 'react-router-dom';
import { configService } from './configService';
import { shouldRedirectToLoginOnSessionExpiry } from '../utils/publicSessionRoutes';

let navigateRef: NavigateFunction | null = null;
let pendingLoginNavigation = false;

/**
 * Enregistre le navigateur React Router (à appeler depuis un composant sous Router).
 */
export function registerSessionNavigator(navigate: NavigateFunction): void {
  navigateRef = navigate;
  if (pendingLoginNavigation) {
    pendingLoginNavigation = false;
    navigate('/login', { replace: true });
  }
}

export function unregisterSessionNavigator(): void {
  navigateRef = null;
}

/**
 * Sur app Capacitor : navigation SPA vers /login (évite un rechargement complet).
 * Sur web : `window.location.assign` (comportement historique, état global remis à zéro).
 */
export function redirectToLogin(): void {
  if (!shouldRedirectToLoginOnSessionExpiry()) {
    return;
  }

  const native = configService.isNative();

  if (native && navigateRef) {
    navigateRef('/login', { replace: true });
    return;
  }

  if (native && !navigateRef) {
    pendingLoginNavigation = true;
    window.setTimeout(() => {
      if (navigateRef) {
        pendingLoginNavigation = false;
        navigateRef('/login', { replace: true });
      } else {
        pendingLoginNavigation = false;
        window.location.assign(`${window.location.origin}/login`);
      }
    }, 300);
    return;
  }

  window.location.assign(`${window.location.origin}/login`);
}

const SESSION_INVALID = 'rintintin:session-invalid';

/**
 * Déconnexion centralisée : sauvegarde redirect /app, puis événement écouté par AuthProvider (logout + redirect).
 */
export function emitSessionInvalid(): void {
  if (typeof window === 'undefined') return;
  try {
    const p = `${window.location.pathname}${window.location.search ?? ''}${window.location.hash ?? ''}`;
    if (p.startsWith('/app')) {
      localStorage.setItem('redirectAfterAuth', p);
    }
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(SESSION_INVALID));
}

export const SESSION_INVALID_EVENT = SESSION_INVALID;
